import {configureStore} from "@reduxjs/toolkit";
import menuReducer from "./menu-slice"
import dashboardReducer from './dashboard-slice';
import utilityReducer from "./utility-slice";
import domainReducer from "./domain-slice";
import authReducer from "./auth-slice";

const store = configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
    reducer: {
        auth: authReducer,
        menu: menuReducer,
        utility: utilityReducer,
        dashboard: dashboardReducer,
        domain: domainReducer,
    }
});

export default store;
